import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-article-share-bar/jb-article-share-bar.css.ts
var jb_article_share_bar_css_default = i`.title{font-family:var(--theme-font-light-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}.title{font-size:var(--theme-typo-body-sm-desktop-fontsize, 0.813rem);font-weight:var(--theme-typo-body-sm-fontweight, var(--theme-font-light-weight, 300));line-height:var(--theme-typo-body-sm-desktop-lineheight, 1.25rem)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{align-items:center;block-size:40px;display:flex;gap:var(--theme-spacing-xs);justify-content:flex-start}@media(min-width: 600px){:host{justify-content:flex-end}}.title{display:inline-block;text-transform:capitalize;user-select:none}`;

export {
  jb_article_share_bar_css_default
};
